import React, { useState } from "react";

import {
  LocationIcon,
  GlassIcon,
  BedIcon,
  WiFiIcon,
  CloseIcon,
  PhoneIcon,
  FamilyIcon,
  ServiceIcon,
  ParkIcon,
  UserIcon,
  DefaultHotelIcon,
} from "../../../../helper/HwIcon";
import imagm from "../../../../assets/img/no-image-holder.png";
import { useHotelUtils } from "../../hooks/useHotelUtils";
import { formatPrice, calcNights, formatePriceFn } from "../../../../helper/commonFunction";
import { useNavigate } from "react-router-dom";
import HotelGalleryPopup from "../../details/components/HotelGalleryPopup";
import { useSelector } from "react-redux";

const imgs = [1, 2, 3, 4];

const AmentiesItem = ({icon, label}) => {
  return (
    <>
      <div className="col-6 col-sm-6 col-md-4">
        <div className="d-flex hw-gapy4 align-items-center hw-fontWeight--500 hw-icon--div">
          {icon}
          {label}
        </div>
      </div>
    </>
  );
};

export const HotelDetailsPopup = ({
  hotelDetails,
  setHotelDetails,
  queryString,
  searchQuery,
}) => {
  const navigate = useNavigate();
  const { agentActiveCurrency,displayPrice } = useSelector((state) => state.userData);
  const { ratings, images, facilitiesPopular } = useHotelUtils(hotelDetails);
  const [showGalleryPopup, setShowGalleryPopup] = useState(false);
  
  const handleViewAllClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowGalleryPopup(true);
  };

  if (!hotelDetails?.id) {
    return null;
  }
  return (
    <>
      <div
        className="hw-modal hw-modal--hotelDetails
     fade show
    "
      >
        <div className="hw-modal-dialog hw-modal-dialog-centered hw-modal-dialog-scrollable">
          <div className="hw-modal-content">
            <div className="hw-modal-header">
              <div className="hw-modal-hotelHeaderTitle">
                <div className="d-flex hw-gapy10 align-items-center mb-2">
                  <h3 className="h2">{hotelDetails?.name}</h3>
                  <div class="hw-hotel--stars">
                    {ratings.map(() => (
                      <span class="filled">★</span>
                    ))}
                  </div>
                </div>
                <div className="d-flex hw-gapy4 align-items-center hw-fontWeight--500 hw-icon--div">
                  <LocationIcon />
                  {hotelDetails?.address}
                </div>
              </div>
              <button
                className="hw-modal--close"
                onClick={() => setHotelDetails({})}
              >
                <CloseIcon />
              </button>
            </div>
            <div className="hw-modal-body">
              <div className="hw-modal--hotelDetailsTop">
                <div className="row hw-hotel--imageGallery">
                  <div className="col-sm-6">
                    <div className="hw-img--main">
                      {
                        images?.[0] ? <img src={images?.[0] ?? imagm} alt="image" /> : <DefaultHotelIcon/>
                      }
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="row hw-gapx15 h-100">
                      {imgs.map((i) => {
                        return (
                          <div className="col-6">
                            <div className="hw-img--grid">
                              <img src={images?.[i] ?? imagm} alt="image" />
                              {i === imgs.length ? (
                                // remove this once UI testing is done
                                // && images?.length > imgs.length
                                <button 
                                  type="button"
                                  className="hw-btn hw-btn--circleWhite" 
                                  onClick={handleViewAllClick}
                                >
                                  View All
                                </button>
                              ) : null}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
                <div className="hw-text18">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: hotelDetails?.description ?? "",
                    }}
                  ></div>
                </div>
              </div>
              <div className="hw-modal--hotelDetailsMap">
                <div className="row">
                    <div className="map-section">
                      <iframe
                        height="450"
                        style={{ border: 0, width: "100%" }}
                        loading="lazy"
                        allowfullscreen
                        referrerpolicy="no-referrer-when-downgrade"
                        src={`https://www.google.com/maps?q=${hotelDetails?.lat},${hotelDetails?.lang}&z=15&output=embed`}
                    ></iframe>
                </div>
              </div>
              </div>
              <div className="hw-modal--hotelPopular">
                <h3 className="h4 mb-20">Popular Facilities</h3>
                <div className="row hw-gapx15">
                  {facilitiesPopular?.length > 0 ? (
                    facilitiesPopular?.map((a) => {
                      return <AmentiesItem icon={a?.icon} label={a?.label} />;
                    })
                  ) : <AmentiesItem icon={<GlassIcon/>} label={'Breakfast Available'} />}
                </div>
              </div>
            </div>

            <div className="hw-modal--footer">
              <div className="d-flex justify-between align-items-center hw-gapy10">
                <div>
                  <h3 className="h4 mb-0">{hotelDetails?.name}</h3>
                  <div className="d-flex hw-gapy4 align-items-center hw-fontWeight--500 mt-1 hw-icon--div">
                    <LocationIcon />
                    {hotelDetails?.address}
                  </div>
                </div>
                <div className="hw-view--more">
                  <h4 class="h4 mb-0">
                    {formatePriceFn(agentActiveCurrency , formatPrice(hotelDetails?.amount,true,true), displayPrice)}
                  </h4>
                  <div className="room hw-text--hidden">
                    <span>Room Only</span>
                    <span>{calcNights(searchQuery?.checkinDate, searchQuery?.checkoutDate)} Night(s)</span>
                  </div>
                  <a
                    className="hw-btn hw-btn--large hw-btn--primary"
                    onClick={() => {
                      navigate(
                        `/hotels/details/${hotelDetails?.id}?${queryString}&vendor=${hotelDetails?.vendor}&amount=${hotelDetails?.amount}&hrCityId=${hotelDetails?.hrCityId || ""}`
                      );
                    }}
                  >
                    <UserIcon />
                    View More
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="hw-modal-backdrop fade show" />
      <HotelGalleryPopup
        show={showGalleryPopup}
        setShow={setShowGalleryPopup}
        images={images}
        initialIndex={0}
      />
    </>
  );
};
